import axios from "axios";
import { getAccessToken } from "./utils.js";
import { getUrl } from "./urls";
import { toast } from "react-toastify";

export const FETCH_CANNED_RESPONSE_LIST = "FETCH_CANNED_RESPONSE_LIST";
export const CREATE_CANNED_RESPONSE = "CREATE_CANNED_RESPONSE";
export const UPDATE_CANNED_RESPONSE = "UPDATE_CANNED_RESPONSE";
export const DELETE_CANNED_RESPONSE = "DELETE_CANNED_RESPONSE";

export function fetchCannedList(company) {
    let res = axios({
        method: "get",
        url: `${getUrl("smr_service")}/templates/list?lite_company_id=${company.companyLiteId}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
    })
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            // toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "FETCH_CANNED_RESPONSE_LIST",
        payload: res,
    };
}

export const createCannedResponse = (data) => {
    let res = axios({
        method: "POST",
        url: `${getUrl("smr_service")}/templates/create/bulk`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data,
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err.response;
        });

    return {
        type: "CREATE_CANNED_RESPONSE",
        payload: res,
    };
};

export function updateCannedResponse(data, id) {
    let res = axios({
        method: "patch",
        url: `${getUrl("smr_service")}/templates/${id}?access-token=${getAccessToken()}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
        data,
    })
        .then((res) => {
            toast.success("Canned Response updated successfully.");
            return res.data.data;
        })
        .catch((err) => {
            if (err.response?.data?.message) toast.error(err.response.data.message);
            else toast.error("Canned Response updation failed.");
            return err;
        });
    return {
        type: "UPDATE_CANNED_RESPONSE",
        payload: res,
    };
}

export function deleteCannedResponse(data) {
    let res = axios({
        method: "delete",
        url: `${getUrl("smr_service")}/templates/${data}?access-token=${getAccessToken()}`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
        },
    })
        .then((res) => {
            // console.log(res.data);
            toast.success("Canned Response deleted successfully.");
            return data;
        })
        .catch((err) => {
            if (err.response?.data?.message) toast.error(err.response.data.message);
            else toast.error("Canned Response deletion failed.");
            return err;
        });
    return {
        type: "DELETE_CANNED_RESPONSE",
        payload: res,
    };
}
